import { Controller } from '@hotwired/stimulus';

// Step 1 of the cancel funnel: collapse the sub-reason chips that do not belong
// to the picked reason, and hold Continue until the pick is complete.
//
// This controller is an enhancement and nothing more. The `required` attribute
// on the radios is what actually gates the submit, and the server re-validates
// the pick. If this file never loads, the page still works — every chip group
// is simply visible at once and Continue is always enabled.
export default class extends Controller {
  static targets = ['reason', 'subGroup', 'submit'];

  connect() {
    this.refresh();
  }

  refresh() {
    const selected = this.element.querySelector('input[name="reason"]:checked');
    const selectedReason = selected ? selected.value : null;
    let complete = Boolean(selected);

    this.reasonTargets.forEach((block) => {
      const group = block.querySelector('[data-cancel-reason-picker-target~="subGroup"]');
      if (!group) return;

      const active = block.dataset.reason === selectedReason;
      group.hidden = !active;
      if (active && !group.querySelector('input[type="radio"]:checked')) complete = false;

      // A hidden chip must not stay checked, or the server gets a sub-reason
      // belonging to a reason the customer moved away from.
      if (!active) {
        group.querySelectorAll('input[type="radio"]').forEach((radio) => {
          radio.checked = false;
        });
      }
    });

    if (this.hasSubmitTarget) this.submitTarget.disabled = !complete;
  }
}
